import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs } from 'swiper';
import { NextBtn, PrevBtn } from '../../../_components/SwiperInterface';
import { DetailImageModal } from './DetailImageModal';
import productImage from '../../../images/product.png';
import { Height } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  'swiper-wrapper1': {
    width: '100%',
    overflow: 'hidden',

    '& .swiper-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: 'max-content',
      margin: 0,
    },
  },
  'single-product__children': {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '100%',
  },
  'single-product-thumb': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    flexShrink: 0,
    width: '70px !important',
    height: '70px !important',
    padding: '7px',
    '&.swiper-slide-thumb-active': {
      border: '2px solid #FFBE00',
      borderRadius: 4,
    },
  },
  'span-discount': {
    position: 'absolute',
    top: 0,
    right: '10px',
    padding: '4px 8px',
    boxSizing: 'border-box',
    backgroundColor: '#FF5252',
    color: '#fff',
    fontWeight: 800,
    fontSize: '13px',
    lineHeight: '160%',
    borderRadius: '4px',
    zIndex: '3'
  }
}));

export const DetailProductSlider = props => {
  const { product, result, promoLabel } = props;

  const photos = result.article.photo.large_photos;

  const [sliderIndex, setSliderIndex] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);

  const classes = useStyles();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const mainSwiperRef = useRef(null);
  const thumbsSwiperRef = useRef(null);

  const syncThumbsToActiveIndex = index => {
    const swipe = thumbsSwiperRef.current;
    if (!swipe || !photos?.length) return;

    const visibleSlides = Math.max(1, Math.floor(swipe.params.slidesPerView || 1));
    const maxIndex = Math.max(0, photos.length - visibleSlides);
    const target = Math.min(Math.max(index - Math.floor(visibleSlides / 2), 0), maxIndex);

    if (swipe.activeIndex !== target) {
      swipe.slideTo(target);
    }
  };

  return (
    <div className="col-12 col-lg-5 col-xxl-5 mb-lg-0 mb-3">
      <div className="single-product-block single-product__sliders">
        <div
          className={clsx(
            classes['single-product__children'],
            'd-none d-sm-flex',
          )}>
          <div>
            <Swiper
              modules={[Thumbs]}
              onSwiper={swiper => {
                thumbsSwiperRef.current = swiper;
                setThumbsSwiper(swiper);
              }}
              watchSlidesProgress
              watchOverflow
              spaceBetween={8}
              slidesPerView={Math.min(photos?.length || 1, 4)}
              slideToClickedSlide
              className={clsx(classes['swiper-wrapper1'])}>
              {photos?.length > 0 ? (
                <>
              {photos?.map((photo, index) => (
                <SwiperSlide
                  key={photo}
                  onClick={() => {
                    mainSwiperRef.current?.slideTo(index);
                    syncThumbsToActiveIndex(index);
                  }}
                  className={clsx(classes['single-product-thumb'])}>
                  <img src={photo} alt="slider-1" />
                </SwiperSlide>
              ))}
                </>
              ) : (
                <SwiperSlide key={1} className={clsx(classes['single-product-thumb'])}>
                  <img alt='slider-1' src={productImage} />
                </SwiperSlide>
                )}
            </Swiper>
          </div>
        </div>
        <div className="single-product__tags product-slider-badge">
            {promoLabel?.length > 0 && (
              <span
                style={{
                  background:
                    promoLabel[0].badge_rgb_code?.split('')[0] === '#'
                      ? promoLabel[0].badge_rgb_code
                      : '#' + promoLabel[0].badge_rgb_code,
                  color: 'white',
                  whiteSpace: 'nowrap',
                }}
                className="info bage-custom-new-style 2">
                <img src={promoLabel[0].badge_image} alt={promoLabel[0].badge_name} />
                {promoLabel[0].badge_name}

              </span>
            )}
          </div>
        <Swiper
          ref={mainSwiperRef}
          className="single-product__parent swiper"
          thumbs={{ swiper: thumbsSwiper }}
          onSwiper={swiper => {
            mainSwiperRef.current = swiper;
          }}
          onSlideChange={e => {
            setSliderIndex(e.activeIndex);
            syncThumbsToActiveIndex(e.activeIndex);
          }}
          modules={[Thumbs]}
          style={{ width: '100%' }}>
          {photos?.length > 0 ? (
            <>
              {photos?.map(photo => (
                <SwiperSlide key={photo}>
                  <div
                    onClick={() => setShowImageModal(!showImageModal)}
                    className="single-product__parent-item swiper-slide cursor-pointer">
                    <img className="mt-0" src={photo || productImage} alt="slider-1" />
                  </div>
                </SwiperSlide>
              ))}
            </>
          ) : (
            <SwiperSlide key={1}>
              <div
                onClick={() => setShowImageModal(!showImageModal)}
                className="single-product__parent-item swiper-slide cursor-pointer">
                <img alt='slider-1' src={productImage} />
              </div>
            </SwiperSlide>
          )}
          <div className="single-product__elements">
            <div className="products-block__slick">
              <PrevBtn isDeactive={sliderIndex === 0} />
              <NextBtn isDeactive={sliderIndex >= (photos?.length || 1) - 1} />
            </div>
            <div className="single-product__tags d-none">
              {promoLabel?.length > 0 && (
                <span
                  style={{
                    background:
                      promoLabel[0].badge_rgb_code?.split('')[0] === '#'
                        ? promoLabel[0].badge_rgb_code
                        : '#' + promoLabel[0].badge_rgb_code,
                    color: 'white',
                    whiteSpace: 'nowrap',
                  }}
                  className="info bage-custom-new-style 2">
                  <img src={promoLabel[0].badge_image} alt={promoLabel[0].badge_name} />
                  {promoLabel[0].badge_name}

                </span>
              )}
            </div>
            {result.isDiscount && (
              <span
                className={classes['span-discount']}>
                – {result.isDiscount}%
              </span>
            )}
          </div>
        </Swiper>
      </div>
      {/* <DetailImageModal
        showImageModal={showImageModal}
        setShowImageModal={setShowImageModal}
        photos={photos}
      /> */}
    </div>
  );
};
